import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Stack, ProgressBar } from 'react-bootstrap';
import { Button, CountDown } from 'lb-components';
import classes from './OtpModal.module.scss';
import classNames from 'classnames';
import { ClosePrimaryIcon, DividerIcon } from '../../../assets/icons/modal';
import { useTranslation } from 'lb-store';

export const OTPModal = ({
  description,
  onSuccess,
  onResend,
  onCancel,
  variant,
  ...props
}) => {
  const ref = useRef();
  const { t } = useTranslation();
  const [smsCode, setSmsCode] = useState('');
  const [error, setError] = useState('');
  const [resend, setResend] = useState(false);
  const [timer, setTimer] = useState(0);

    console.log('description',description)
  if(!description){
      description = t('გთხოვთ, მიუთითეთ თქვენს ნომერზე გამოგზავნილი SMS კოდი');
  }

  useEffect(() => {
      console.log('description',description)
    setTimeout(() => {
      if (ref.current) {
        //console.log('focus');
        ref.current.focus();
      }
    }, 100);
  }, []);

  return (
    <Modal
      onHide={onCancel}
      container={document.getElementById('lb-events')}
      contentClassName={classNames(classes.modal, {
        [classes.dark]: true,
      })}
      {...props}
    >
      <Modal.Header
        className={classes.header}
        style={{ '--close': `url(${ClosePrimaryIcon})` }}
        closeButton
        closeVariant={variant === 'dark' ? 'white' : null}
      >
        {t('ერთჯერადი SMS კოდის შემოწმება')}
      </Modal.Header>
      <Modal.Body className={classes.body}>
        <Form
          className={classes.form}
          onSubmit={(e) => {
            e.preventDefault();
            onSuccess(
              smsCode,
              (error) => {
                setSmsCode('');
                setError(error);
              },
              onCancel
            );
          }}
        >
          <Form.Group className={classes.formGroup}>
            <Form.Label>{description}</Form.Label>
            <div style={{ position: 'relative' }}>
              <Form.Control
                ref={ref}
                type={'number'}
                isInvalid={error}
                value={smsCode}
                autoComplete={'one-time-code'}
                onChange={(e) => {
                  setError('');
                  setSmsCode(e.target.value);
                }}
              />
              {resend && (
                <div
                  style={{
                    position: 'absolute',
                    right: error ? 25 : 2,
                    top: '50%',
                    transform: 'translateY(-50%) scale(0.85)',
                  }}
                >
                  <CountDown
                    onComplete={() => setResend(false)}
                    Duration={timer}
                    Colors={['#ffca2c']}
                    ColorsTime={[0]}
                    BackgroundColor={'#373940'}
                  />
                </div>
              )}
            </div>
          </Form.Group>
          <Form.Group className={classes.formGroup}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'space-between',
              }}
            >
              <div>
                {!resend && (
                  <Form.Label
                    style={{ textDecoration: 'underline' }}
                    onClick={() =>
                      onResend((time, error) => {
                        setError(error || '');
                        setResend(true);
                        setTimer(time);
                        setSmsCode('');
                        if (ref.current) {
                          ref.current.focus();
                        }
                      })
                    }
                  >
                    {t('თავიდან გაგზავნა')}
                  </Form.Label>
                )}
              </div>

              <div
                style={{
                  flex: 1,
                  justifyContent: 'flex-end',
                  display: 'flex',
                  fontSize: '1.15rem',
                  fontFamily: 'lbet-nus-regular',
                  color: 'red',
                  marginLeft: '2rem',
                }}
              >
                {error}
              </div>
            </div>
          </Form.Group>
          <div className={classes.buttonsContainer}>
            <Button
              size={'sm'}
              variant={'success'}
              type='submit'
              style={{ marginRight: '2rem' }}
            >
              {t('დასტური')}
            </Button>
            <Button
              size={'sm'}
              variant={'secondary'}
              onClick={onCancel}
              type='button'
            >
              {t('გაუქმება')}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

OTPModal.propTypes = {
  show: PropTypes.bool,
  centered: PropTypes.bool,
  description: PropTypes.string,
  onSuccess: PropTypes.func,
  onResend: PropTypes.func,
  onCancel: PropTypes.func,
  variant: PropTypes.string,
};
OTPModal.defaultProps = {
  show: true,
  centered: true,
  //description: 'გთხოვთ, მიუთითეთ თქვენს ნომერზე გამოგზავნილი SMS კოდი',
  variant: 'dark',
  onResend: () => console.log('resend'),
};
